import * as React from "react";
import {
  required,
  NumberInput,
  BooleanInput,
  minValue,
  maxValue,
} from "react-admin";

const createGasBrandMerchant = () => (
  <>
    <NumberInput
      sx={{ width: "14%" }}
      source="priority"
      min={0}
      max={32000}
      validate={[required(), minValue(0), maxValue(32000)]}
      defaultValue={0}
    />
    <BooleanInput source="partner_gas_brand" validate={[required()]} />
  </>
);

export default createGasBrandMerchant;
